export default IconSearchOff => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-search-off" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M5.039 5.062a7 7 0 0 0 9.91 9.89m1.584 -2.434a7 7 0 0 0 -9.038 -9.057" />
  <path d="M3 3l18 18" />
</svg>`;